// src/components/HeroSlider.jsx
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation, EffectFade } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/effect-fade';
import './HeroSlider.css';

const HeroSlider = () => {
  const [slides, setSlides] = useState([]);

  useEffect(() => {
    loadSliderSettings();
  }, []);

  const loadSliderSettings = async () => {
    try {
      const response = await fetch('https://demo-site.storii.com.pk/demo-api/public/get-settings.php');
      const data = await response.json();

      if (data.success && data.settings) {
        const settings = data.settings;

        // Max 2 slides now (was 3)
        const sliderSlides = [];
        for (let i = 1; i <= 2; i++) {
          const imageUrl = settings[`slider_image_${i}`];
          if (imageUrl && imageUrl.trim() !== '') {
            sliderSlides.push({
              id: i,
              title: settings[`slider_title_${i}`] || '',
              subtitle: settings[`slider_subtitle_${i}`] || '',
              buttonText: settings[`slider_button_text_${i}`] || 'Shop Now',
              buttonLink: settings[`slider_button_link_${i}`] || '/shop',
              image: imageUrl,
            });
          } else {
            sliderSlides.push({
              id: i,
              title: '',
              subtitle: '',
              buttonText: 'Go to Settings',
              buttonLink: '/admin/settings',
              image: 'https://via.placeholder.com/1920x600?text=Upload+Slide+Image',
            });
          }
        }

        setSlides(sliderSlides);
      }
    } catch (error) {
      console.error('Error loading slider settings:', error);
    }
  };

  return (
    <div className="hero-slider-container">
      <Swiper
        modules={[Autoplay, Pagination, Navigation, EffectFade]}
        spaceBetween={0}
        slidesPerView={1}
        navigation={true}
        pagination={{ clickable: true }}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        effect="fade"
        fadeEffect={{
          crossFade: true
        }}
        // loop removed — with only 2 slides, loop mode's DOM cloning was
        // producing duplicate slide nodes whose buttons had no working
        // React click handlers. Prev/Next simply toggle between the two
        // real slides now, which is all that's needed here.
        speed={1000}
        className="hero-swiper"
      >
        {slides.map((slide) => (
          <SwiperSlide key={slide.id}>
            <div
              className="hero-slide"
              style={{
                '--slide-bg-image': `url(${slide.image})`,
                backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url(${slide.image})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
              }}
            >
              <div className="hero-slide-content">
                {slide.title && (
                  <h1 className="hero-slide-title">{slide.title}</h1>
                )}
                {slide.subtitle && (
                  <p className="hero-slide-subtitle">{slide.subtitle}</p>
                )}
                <Link to={slide.buttonLink} className="slide-btn">
                  {slide.buttonText} →
                </Link>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default HeroSlider;